import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Subject Search]'

export const resetState = createAction(
    `${SOURCE} ResetState`,
)

export const setState = createAction(
    `${SOURCE} SetState`, props<{ data: any }>()
)

export const resetItemCollection = createAction(
    `${SOURCE} ResetItemCollection`,
)

export const setItemCollection = createAction(
    `${SOURCE} SetItemCollection`, props<{ itemCollection: any[] }>()
)

export const resetFilterCriteria = createAction(
    `${SOURCE} ResetFilterCriteria`,
)

export const setFilterCriteria = createAction(
    `${SOURCE} SetFilterCriteria`, props<{ filterCriteria: any }>()
)

export const updateFilterCriteria = createAction(
    `${SOURCE} UpdateFilterCriteria`, props<{ criteriaFragment: any }>()
)

export const resetSubjectId = createAction(
    `${SOURCE} ResetSubjectId`,
)

export const setSubjectId = createAction(
    `${SOURCE} SetSubjectId`, props<{ subjectId: number }>()
)

export const noAction = createAction(
    `${SOURCE} No Action`,
)